/// <amd-module name="Build/Admin/Common/Components/PoolTypeIcon" />
import * as React from "react";

import { Icon } from "VSSUI/Icon";
import { css } from "VSSUI/Util";

export interface IPoolTypeIconProps {
    isHosted?: boolean;
    isElastic?: boolean;
    className?: string;
}

export class PoolTypeIcon extends React.PureComponent<IPoolTypeIconProps> {
    public render(): JSX.Element {
        let poolIconName: string;
        if (this.props.isElastic) {
            poolIconName = "AzureLogo";
        }
        else if (this.props.isHosted) {
            poolIconName = "CloudWeather";
        }
        else {
            poolIconName = "Server";
        }

        return (
            <div className={css(this.props.className, "pipelines-pool-type-icon flex-row flex-center justify-center")}>
                <Icon className="fontSizeML" iconName={poolIconName} />
            </div>
        );
    }
}
